import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/article/page";
import SneakerArticle from "@/pages/article/sneaker";
import BudgetArticle from "@/pages/article/budget";
import ComparisonArticle from "@/pages/article/comparison";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guide-2026",
    element: <ArticleGuide />,
  },
  {
    path: "/best-sneaker-spreadsheet-finds-2026",
    element: <SneakerArticle />,
  },
  {
    path: "/budget-spreadsheet-guide-2026",
    element: <BudgetArticle />,
  },
  {
    path: "/cssbuy-vs-kakobuy-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;